import React, { Component } from "react";

class ChartErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Chart Error:", error);
    console.error("Chart Error Info:", errorInfo);
  }

  // Reset error state if key changes (to allow retrying)
  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-full flex items-center justify-center p-4">
          <div className="text-center">
            <div className="text-red-500 font-semibold mb-2">
              Chart could not be displayed
            </div>
            <div className="text-gray-500 text-sm mb-3">
              {this.state.error?.message ||
                "An error occurred while rendering the chart."}
            </div>
            {this.props.onRetry && (
              <button
                onClick={this.props.onRetry}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
              >
                Retry
              </button>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChartErrorBoundary;
